import core from '@fireswan/core';

export const getPickSelection = pick => {
  const market = core.enums.picks.markets;

  switch (pick.pick) {
    case market.HOME:
      return pick.event.home && pick.event.home.name;
    case market.AWAY:
      return pick.event.away && pick.event.away.name;
    case market.DRAW:
      return 'Draw';
    case market.LOSE:
      return 'Lose';
    case market.WIN:
      return 'Win';
    case market['TGU2.5']:
      return 'Total Under 2.5';
    case market['TGO2.5']:
      return 'Total Over 2.5';
    case market['BTTS.YES']:
      return 'BTTS:YES';
    case market['BTTS.NO']:
      return 'BTTS:NO';
    default:
      return null;
  }
};

export const pickOddsToFloat = pick => {
  const odds = pick.odd || pick.odds || 0; // TODO legacy
  return odds.toFixed(2);
};

export const getPickTimestamp = event => {
  return (event.time && event.time._seconds * 1000) || Number(event.id.substr(-13));
};

export const getPickMarket = selection => {
  const market = core.enums.picks.markets;

  switch (selection) {
    case market.HOME:
    case market.AWAY:
    case market.DRAW:
    case market.LOSE:
    case market.WIN:
      return 'Full time result';
    case market['TGU2.5']:
    case market['TGO2.5']:
      return 'Total Goals';

    case market['BTTS.YES']:
    case market['BTTS.NO']:
      return 'Both teams to score';

    default:
      return null;
  }
};

export const getPickResult = pick => {
  const pickResults = core.enums.picks.results;
  if (pick.result === pickResults.WIN) {
    return true;
  }
  if (pick.result === pickResults.LOSE) {
    return false;
  }
  return pick.result;
};
